import React, { useState } from 'react';

const STATUS_COLORS = {
  idle: '#6b7280',
  running: '#22c55e',
  completed: '#16a34a',
  failed: '#ef4444',
};

export default function ABTabBar({ tabs, activeTabId, onSelect, onAdd, onClose, onRename }) {
  const [editingId, setEditingId] = useState(null);
  const [editValue, setEditValue] = useState('');

  const handleDoubleClick = (tab) => {
    setEditingId(tab.id);
    setEditValue(tab.label);
  };

  const commitRename = () => {
    if (editingId && editValue.trim()) {
      onRename(editingId, editValue.trim());
    }
    setEditingId(null);
  };

  const tabStatus = (tab) => {
    if (tab.isRunning) return 'running';
    const st = tab.executionState?.status;
    if (st === 'completed') return 'completed';
    if (st === 'failed') return 'failed';
    return 'idle';
  };

  return (
    <div className="ab-tab-bar">
      {tabs.map((tab) => {
        const status = tabStatus(tab);
        const isActive = tab.id === activeTabId;
        return (
          <div
            key={tab.id}
            className={`ab-tab-btn ${isActive ? 'active' : ''}`}
            onClick={() => onSelect(tab.id)}
          >
            <span
              className={`tab-dot ${status}${status === 'running' ? ' pulse' : ''}`}
              style={{ backgroundColor: STATUS_COLORS[status] }}
            />
            {editingId === tab.id ? (
              <input
                className="tab-rename-input"
                value={editValue}
                autoFocus
                onChange={(e) => setEditValue(e.target.value)}
                onBlur={commitRename}
                onKeyDown={(e) => { if (e.key === 'Enter') commitRename(); }}
                onClick={(e) => e.stopPropagation()}
              />
            ) : (
              <span className="tab-label" onDoubleClick={() => handleDoubleClick(tab)}>
                {tab.label}
              </span>
            )}
            <button
              className="tab-close"
              onClick={(e) => {
                e.stopPropagation();
                if (tab.isRunning) {
                  if (!window.confirm('This tab is running. Close anyway?')) return;
                }
                onClose(tab.id);
              }}
            >
              &times;
            </button>
          </div>
        );
      })}
      <button className="ab-tab-add" onClick={onAdd} title="Add new tab">+</button>
    </div>
  );
}
